import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import CarrierProfilesPage from '@/pages/CarrierProfilesPage';
import AppetiteSignalsPage from '@/pages/AppetiteSignalsPage';
import RegulatoryWatchPage from '@/pages/RegulatoryWatchPage';

export default function MarketIntelModule() {
  const tabs = [
    { id: 'carriers', label: 'Carrier Profiles', content: <CarrierProfilesPage /> },
    { id: 'appetite', label: 'Appetite Signals', content: <AppetiteSignalsPage /> },
    { id: 'regulatory', label: 'Regulatory Watch', content: <RegulatoryWatchPage /> },
  ];

  return (
    <ModuleShell title="Market Intelligence" subtitle="Carrier figures, appetite signals and the regulatory envelope — owner/admin only, read-only" tabs={tabs} />
  );
}
